function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.361,
    height: 27.59,
    viewBox: "0 0 42.361 27.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10790",
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 209",
    transform: "translate(1.5 1.5)",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M0 0h39.361"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 210",
    transform: "translate(1.5 13.795)",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M0 0h39.361"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 211",
    transform: "translate(1.5 26.09)",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M0 0h39.361"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.9fa5223d.svg";
export { ForwardRef as ReactComponent };